var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92664 3.20062L3.28366 2.8436C4.06471 2.06255 5.33104 2.06255 6.11209 2.8436L6.73134 3.46285C7.36797 4.09948 7.50074 5.08302 7.05571 5.86567L7.01911 5.93002C6.66257 6.55705 6.66426 7.33297 7.08715 7.91731C7.29785 8.20844 7.53587 8.51002 7.76201 8.73616C7.98814 8.96229 8.28972 9.20032 8.58085 9.41101C9.16519 9.8339 9.94111 9.83559 10.5681 9.47905L10.6325 9.44245C11.4151 8.99742 12.3987 9.13019 13.0353 9.76682L13.6546 10.3861C14.4356 11.1671 14.4356 12.4335 13.6546 13.2145L13.2975 13.5715C12.9225 13.9466 12.4115 14.1556 11.8958 14.0316C10.7936 13.7667 8.66965 12.9436 6.11209 10.3861C3.55453 7.82851 2.73145 5.70458 2.46656 4.60239C2.34261 4.08664 2.55157 3.5757 2.92664 3.20062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.05be0a1a3a9fbe2954428a1ac423ae33.svg";
export { ForwardRef as ReactComponent };